<template>
  <div>
    <b-card>
      <b-row class="px-1 align-items-center justify-content-between">

       <international-donations-filters  @filterChanged="onFilterChanged"></international-donations-filters>
      </b-row>
      <hr />

    <data-table
      ep="v2/international-donations"
      id="MoneyTransferredAbroad"
      :fields="fields"
      striped
      ref="NationalDonationTable"
    >
      <template #cell(type)="{ value }" >

        <b-badge
          pill
          :variant="value === 'bank_donations' ? 'light-primary' : value === 'in_kind_donations' ? 'light-secondary' : 'light-success'"
        >
          {{ value === 'bank_donations' ? 'تبرع مالي' : value === 'in_kind_donations' ? 'تبرع عيني' : 'تبرع بمركبة' }}
        </b-badge>
      </template>
      <template #cell(identification_file)="{ value }" >
        <b-button
          size="sm"
          @click="$router.push({ name: 'file-view', query: { ep: value } })"
          variant="flat-success"
        >
          <feather-icon class="mx-25" icon="EyeIcon" />
          عرض الملف
        </b-button>
      </template>

       <template #cell(_)="row">
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="flat-info"
            size="sm"
            class="btn-icon rounded-circle"
            title="عرض التبرع"
            @click="showDonations(row.item.id)"
          >
            <feather-icon icon="EyeIcon" size="1.8x" color="#4fc98c" />
          </b-button>

        </div>
      </template>
    </data-table>

    </b-card>
    <show-international-donation
      v-model="isShow"
      :initializeForm="form"
      ref="currentModalRef"
      >
    </show-international-donation>
  </div>
</template>

<script>
import { BCard, BRow, BCol, BFormFile, BButton , BDropdown, BDropdownItem, VBTooltip ,BBadge} from "bootstrap-vue";
import formSelect from "@/components/form-select";
import { mapGetters, mapActions } from "vuex";
import InternationalDonationsFilters from "../../components/InternationalDonationsFilters.vue"
import ShowInternationalDonation from "../../components/ShowInternationalDonation.vue"
import DataTable from "@/components/data-table";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    DataTable,
    BCard,
    BRow,
    BCol,
    BFormFile,
    BButton,
    BDropdown, BDropdownItem, VBTooltip , ShowInternationalDonation ,
    InternationalDonationsFilters , BBadge ,formSelect
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  watch:{
    activeFilter(val) {
      if(val == 'all'){
        this.$refs.NationalDonationTable.setQueryParams({});
        this.$refs.NationalDonationTable.refreshTable();
      }
      else{

        this.$refs.NationalDonationTable.setQueryParams({ tab : this.activeFilter });
        this.$refs.NationalDonationTable.refreshTable();
      }
    },
  },
  mounted() {
    this.activeFilter = "all"
  },
  data() {
    return {
      form : {},
      activeFilter : null,
      isShow : false ,
      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "type",
          label: "نوع التبرع",
        },
        {
          key: "country_name",
          label: "الدولة",
        },
        {
          key: "identification_file",
          label: "صورة عن الهوية أو جواز سفر المتبرع",
        },
        "_",
      ]

    };
  },
  methods: {
    ...mapActions("Financial", [
      "fetchNationalDonations",
    ]),
    onFilterChanged(filter) {
      this.activeFilter = filter;
    },
     async showDonations(id){
      console.log("id" , id)

      this.$refs.currentModalRef.init({'id' : id})
      // await this.fetchNationalDonations(id).then(()=> {
      //     // this.idEdit = id
      //     // this.type_of_transaction = type.slug
      //     // this.oldData = this.Transaction.transactionRequestData
      //     // this.currentModalData = true
      // });
      this.isShow = true
    },
  }
};
</script>
